import { DetailStep } from './DetailStep'
export class ContactRequest {

    public vouchers: string[]  = [];

    constructor(
        public name: string,
        public email: string,
        public test: string,
        public system: string,
        public fraction: string,
        public miniatures: Object,
        public info?: string,
    ) { }
}


// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/model/contact/contact-request.ts